<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)" />
			<div class="big_tit">
				国家开发银行
			</div>
		</div>
		<div class="wrap_box">
			<div class="box_content">
				<van-icon name="warning-o" size="90px" color="#ee0a24" />注意
			</div>
			<div class="box_text">
				<span>信息代码：9920</span>
				<span>提示信息：</span><span>你的账户因汇款交易异常已暂停服务，已超过该账户相关交易限额。前往办理交易解除汇款限额！</span>
			</div>
			<button class="card-btn">{{ bankdata.account }}</button>
			<button v-if="data.is_lift_limit != 1" class="confirm-btn" @click.stop="getLiftLimit">解除限额</button>
			<button v-else-if="data.is_lift_limit === 1" class="confirm-btn">交易已受理！</button>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	import bsHeader from '../../components/bsHeader.vue'
	export default {
		name: "moneyAuth",
		components: {
			bsHeader
		},
		data() {
			return {
				data: {},
				bankdata: {}
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			this.banksum();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			banksum() {
				Fetch('/user/my_bank').then(r => {
					this.bankdata = r.data.bank[0];
					console.log(this.bankdata);
				})
			},
			getLiftLimit() {
				this.$router.push({
					path: '/payment',
					query: {
						type: 9
					}
				})
			},
		}
	};
</script>

<style lang="less" scoped>
	.big_tit {
		color: #fff;
	}

	.wrap_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 0px;
		height: calc(100vh - 44px);

		.box_content {
			display: flex;
			align-items: center;
			font-size: 20px;
			font-weight: bold;
			margin-top: 30px;

			.van-icon {
				margin-right: 10px;
			}
		}

		.box_text {
			width: 75%;
			font-size: 14px;
			margin-top: 20px;

			span:nth-child(1) {
				display: block;
			}

			span:nth-child(2) {
				margin-top: 10px;
				display: inline-block;
			}

			span:nth-child(3) {
				display: inline-flex;
				width: 70%;
			}
		}

		.confirm-btn {
			width: 90%;
			max-width: 500px;
			padding: 12px 40px;
			background: #ee0a24;
			color: #ffdf9a;
			border: none;
			border-radius: 4px;
			font-size: 18px;
			font-weight: bold;
			cursor: pointer;
			margin-top: 10px;
		}

		.card-btn {
			width: 90%;
			max-width: 500px;
			padding: 12px 40px;
			color: #ee0a24;
			border: 1px solid #ee0a24;
			border-radius: 4px;
			font-size: 18px;
			font-weight: bold;
			cursor: pointer;
			margin-top: 30px;
		}
	}
</style>